<template>
  <div id="integrations-list">
    <div class="integration-card">
      <div class="integration-logo">
        <img
          :src="logo"
          :alt="alt"
          height="56px"
          width="56px"
        >
      </div>
      <div class="integration-content">
        <h3>{{ name }}</h3>
        <p>
          {{ description }}
        </p>
      </div>
      <template v-if="integrationState.toLowerCase() === integrationStates.ACTIVE.toLowerCase() || integrationState.toLowerCase() === integrationStates.CONFIGURE.toLowerCase()">
        <div class="active-integration-action">
          <template v-if="configurable">
            <v-btn
              color="secondary"
              class="ml-0"
              max-width="159"
              min-width="159"
              :to="{ name: 'Property Mapping', params: { orgId: $route.params.orgId, partnerName: name }}"
            >
              Configure
            </v-btn>
          </template>
          <template v-else>
            <v-icon
              color="#33A08E"
              class="mr-2"
            >
              $faCheck
            </v-icon>
            <span style="color: #456E6C;">ACTIVE</span>
          </template>
          <v-btn
            color="primary"
            text
            fab
            @click="deactivate(name, id)"
          >
            <v-icon>$faTimes</v-icon>
          </v-btn>
        </div>
      </template>
      <template v-else-if="integrationState.toLowerCase() === integrationStates.WAITING_FOR_APPROVAL.toLowerCase()">
        <div class="pending-integration">
          Waiting for approval
        </div>
      </template>
      <template v-else-if="integrationState.toLowerCase() === integrationStates.CONNECT.toLowerCase()">
        <div class="available-integration-action">
          <v-btn
            color="primary"
            target="_blank"
            class="icon-btn d-flex align-center px-5"
            @click="enableIntegration"
          >
            <v-icon
              size="15"
              class="mr-2"
            >
              $faPlus
            </v-icon>
            <span class="btn-txt">Connect</span>
          </v-btn>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
  import integrationStates from '@/helpers/integration-constants.js'
  import { mapGetters } from 'vuex'

  export default {
    name: 'IntegrationItem',
    components: {
    },
    props: {
      alt: { type: String, default: '' },
      description: String,
      name: String,
      id: Number,
      logo: String,
      configurable: Boolean,
      integrationState: {
        type: String,
        validator: v => Object.values(integrationStates).includes(v),
      },
    },
    computed: {
      ...mapGetters({
        selectedOrg: 'Permissions/currentSelectedOrg',
      }),
      integrationStates () {
        return integrationStates
      },
    },
    methods: {
      enableIntegration (integration) {
        this.$emit('enable-integration', integration)
      },
      deactivate (name, id) {
        this.$emit('deactivate-integration', { name, id })
      },
    },
  }
</script>
<style lang="scss">
#integrations-list {
  .integration-card {
    width: 100%;
    height: auto;
    display: flex;
    align-items: center;
    min-height: 103px;
    margin: 20px 0 20px 0;
    padding: 20px;
    background: #FFFFFF;
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.3);
    border-radius: 4px;
    .integration-logo {
      width: 56px;
      margin-right: 20px;
    }
    .integration-content {
      flex-grow: 1;
      h3 {
        font-weight: 600;
        font-size: 22px;
        line-height: 29px;
      }
      p {
        font-size: 16px;
        line-height: 19px;
        letter-spacing: 0.5px;
      }
    }
    .available-integration-action {
      a {
        width: 128px;
        height: 40px;
        span {
          font-size: 13px;
        }
        .btn-txt {
          margin-left: 7px;
        }
      }
    }
    .active-integration-action {
      flex-wrap: nowrap;
      min-width: 225px;
      .v-btn {
        margin-left: 10px;
      }
    }
  }
}
.pending-integration {
  font-size: 13px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 1px;
  text-align: left;
  color: $muted;
  text-transform: uppercase;
  min-width: 174px;
}
</style>
